import React from 'react';
import Select from 'react-select';
import { PRODUCT_TYPES } from '../../../constants';

const OrderHeader = ({ selectedProductType, setSelectedProductType, isLoading }) => {
  const options = Object.entries(PRODUCT_TYPES).map(([key, value]) => ({
    value: key,
    label: value.label
  }));

  const formatOptionLabel = ({ label, value }, { context }) => {
    const isMenu = context === 'menu';
    const isSelected = selectedProductType === value;

    // Seçili değerin renkleri (Control içinde) beyaz arka planda düzgün görünmeli
    const iconBgColor = isMenu && isSelected ? 'rgba(255,255,255,0.2)' : '#fff7ed';
    const iconColor = isMenu && isSelected ? 'white' : '#b04309';
    const textColor = isMenu && isSelected ? 'white' : '#1e293b';

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: isMenu ? '0' : '0' }}>
        <div style={{
          width: isMenu ? '28px' : '30px',
          height: isMenu ? '28px' : '30px',
          borderRadius: '8px',
          backgroundColor: iconBgColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: iconColor,
          fontSize: isMenu ? '14px' : '15px',
          transition: 'all 0.2s'
        }}>
          <i className={`fas fa-${getTypeIcon(value)}`}></i>
        </div>
        <span style={{ fontWeight: '700', fontSize: '14px', color: textColor }}>
          {label}
        </span>
      </div>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: '16px',
      padding: '2px 8px',
      borderColor: state.isFocused ? '#b04309' : '#e2e8f0',
      boxShadow: state.isFocused ? '0 0 0 4px rgba(176, 67, 9, 0.1)' : 'none',
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease',
      cursor: 'pointer',
      minHeight: '48px',
      '&:hover': {
        borderColor: '#b04309',
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 12px -2px rgba(0, 0, 0, 0.05)'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      paddingLeft: '0px',
      marginLeft: '-2px'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1e293b',
      margin: 0
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '6px 12px',
      backgroundColor: state.isSelected
        ? '#b04309'
        : state.isFocused
          ? '#fff7ed'
          : 'transparent',
      color: state.isSelected ? 'white' : '#1e293b',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:active': {
        backgroundColor: '#b04309'
      }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -6px rgba(0, 0, 0, 0.04)',
      border: '1px solid #f1f5f9',
      marginTop: '8px',
      padding: '8px'
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '4px',
      '&::-webkit-scrollbar': {
        width: '6px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#e2e8f0',
        borderRadius: '10px'
      }
    }),
    singleValue: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center'
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#b04309' : '#94a3b8',
      '&:hover': { color: '#b04309' }
    })
  };

  return (
    <div className="product-type-selection" style={{ marginBottom: '35px' }}>
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '12px',
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        fontWeight: '800',
        color: '#64748b'
      }}>
        <i className="fas fa-shapes" style={{ color: '#b04309' }}></i>
        Ürün Tipi Seçimi
      </label>
      <Select
        options={options}
        value={options.find(o => o.value === selectedProductType)}
        onChange={(option) => setSelectedProductType(option ? option.value : '')}
        isLoading={isLoading}
        placeholder="Hangi ürün tipini seçmek istersiniz?"
        isSearchable={false}
        styles={customStyles}
        formatOptionLabel={formatOptionLabel}
      />
    </div>
  );
};

// Yardımcı fonksiyon - İkonları belirler
const getTypeIcon = (type) => {
  switch (type) {
    case 'tul': return 'scroll';
    case 'kanat': return 'border-style';
    case 'stor': return 'window-maximize';
    case 'zebra': return 'align-justify';
    case 'ahsapJaluzi': return 'bars';
    case 'metalJaluzi': return 'columns';
    case 'dikeyPerde': return 'grip-vertical';
    case 'dikeyPvc': return 'stream';
    case 'dikeyStor': return 'align-center';
    case 'plise': return 'th-list';
    case 'katlamaliPerde': return 'layer-group';
    case 'aksesuar': return 'tags';
    case 'raySistemi': return 'road';
    case 'rustik': return 'ellipsis-h';
    default: return 'dot-circle';
  }
};

export default OrderHeader;
